import { Link } from "react-router-dom";
import { typeCounts } from "@/lib/media";

const entries = [
  {
    type: "movie",
    label: "电影",
    english: "Movies",
    icon: "ri-film-line",
    description: "悬疑、科幻、家庭与音乐，一场不到两小时的完整旅程。",
    count: typeCounts.movie,
    cardClass: "bg-primary-50 border-primary-100",
    iconClass: "bg-primary-100 text-primary-700",
    accentClass: "text-primary-600",
  },
  {
    type: "tv",
    label: "电视剧",
    english: "Series",
    icon: "ri-tv-2-line",
    description: "从治愈小院到海岛悬案，把一整个季节交给一部剧。",
    count: typeCounts.tv,
    cardClass: "bg-accent-50 border-accent-100",
    iconClass: "bg-accent-100 text-accent-700",
    accentClass: "text-accent-700",
  },
  {
    type: "variety",
    label: "综艺",
    english: "Variety",
    icon: "ri-mic-line",
    description: "户外、音乐与慢生活纪实，下饭时刻的最佳陪伴。",
    count: typeCounts.variety,
    cardClass: "bg-secondary-50 border-secondary-200",
    iconClass: "bg-secondary-100 text-secondary-800",
    accentClass: "text-secondary-700",
  },
];

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 py-12 md:px-8 md:py-16" aria-label="影视分类入口">
      <div className="mb-7 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-[11px] uppercase tracking-[0.3em] text-primary-600">Browse by category</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[30px]">
            按类别浏览
          </h2>
        </div>
        <p className="max-w-md text-sm leading-relaxed text-foreground-500">
          三大内容分类，各自独立的筛选维度。先从想看的形式开始，再慢慢缩小范围。
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3 md:gap-5 lg:grid-cols-3">
        {entries.map((entry) => (
          <Link
            key={entry.type}
            to={`/category/${entry.type}`}
            className={`group relative flex cursor-pointer flex-col justify-between overflow-hidden rounded-lg border p-4 transition-transform duration-300 hover:-translate-y-1 md:p-6 ${entry.cardClass}`}
          >
            <div className="flex items-start justify-between">
              <span
                className={`flex h-10 w-10 items-center justify-center rounded-lg md:h-12 md:w-12 ${entry.iconClass}`}
              >
                <i className={`${entry.icon} text-xl md:text-2xl`} />
              </span>
              <span className={`font-heading text-2xl font-bold opacity-30 md:text-4xl ${entry.accentClass}`}>
                {String(entry.count).padStart(2, "0")}
              </span>
            </div>

            <div className="mt-6 md:mt-10">
              <p className="text-[10px] uppercase tracking-[0.25em] text-foreground-400">
                {entry.english}
              </p>
              <h3 className="mt-1 font-heading text-lg font-bold text-foreground-950 md:text-xl">
                {entry.label}
              </h3>
              <p className="mt-2 hidden text-xs leading-relaxed text-foreground-600 sm:block md:text-[13px]">
                {entry.description}
              </p>
              <span
                className={`mt-4 inline-flex items-center gap-1 text-xs font-medium ${entry.accentClass}`}
              >
                进入专区
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}